// 标识符正则表达式
export const identifierRegex = /^[A-Za-z0-9_]+$/
// 手机号码正则表达式
export const mobileRegex = /^1[3|4|5|7|8][0-9]\d{4,8}$/
// 区号+座机号码+分机号码：
export const phoneRegex=/^(0[0-9]{2,3}-)?([2-9][0-9]{6,7})+([0-9]{1,4})?$/
// 邮箱正则表达式
export const emailRegex = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
// 费率校验
export const chargingRegex = /^([1-9]\d{0,0}|0)(\.\d{1,4})?$/
// 金额校验
export const amountRegex = /^([1-9]\d{0,5}|0)(\.\d{1,2})?$/

const numberRegex = /^[0-9]*$/ /* 纯数字*/
const nameRegex = /^[\u4E00-\u9FA5A-Za-z0-9]+$/ /* 中文、英文、数字但不包括下划线等符号*/
export function checkNum(rule, value, callback) {
  setTimeout(() => {
    if (!numberRegex.test(value)) { callback(new Error('请输入整数')) }
    else if(value > 999999999999999) { callback(new Error('请输入15位数字')) }
    callback()
  }, 100)
}
export function checkName(rule, value, callback) {
  setTimeout(() => {
    if (!nameRegex.test(value)) { callback(new Error('包含非法字符')) }
    callback()
  }, 100)
}
